import { httpClient } from '@/services/http/client'
import { buildApiUrl, ApiService } from '@/config/api.config'
import type { Country } from '@/types/entities/country'

/**
 * API методы для работы со справочником стран
 */
export const countriesApi = {
  /**
   * Получить список всех стран
   */
  async getAll(): Promise<Country[]> {
    const url = buildApiUrl(ApiService.ClientData, 'references/countries')
    const response = await httpClient.get<{ countries: Country[] }>(url)
    return response.countries || []
  },
}
